import React from 'react'
import styles from './index.module.scss'

import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';

const text1 = 
 <div>
       <h3>To register with DueFocus in the desktop application:</h3>
       <p>Press the “Sign Up” button on the Login screen;</p>
       <p>Fill all the required fields, accept the terms of use, and click “Sign Up” button;</p>
       <p>An activation letter will be sent to your e-mail, where you should click the confirmation link;</p>
       <p>After the registration you can start using the application.</p>
    </div>
 ;
 const text2 = 
<div>
    <p>“Estimated time” is the time set to work on the performance of the entire task.</p>
    <p>“Planned time” is the time set to work on the task within a particular day.</p>
 </div>
;
const text3 = 
<div>
    <p>“Cold Start” is a function that lets users start working with DueFocus much faster after installing. It can start tracking time without planning tasks. As a result, user can accurately reassign the time spent into a particular task(s) later.</p>
 </div>
;
const text4 = 
<div>
    <p>You can switch the “Screenshotting” tumbler to "On/Off" if screenshot frequency is set to "None" value in project settings. Note: Switcher can be moved only if time is not tracking</p>
 </div>
;
const text5 = 
<div>
    <h3>To use “Manual Reporting”, you should:</h3>
    <p>1. Click on timeline to select the period for which you want to create a manual report;</p>
    <p>2. Fill in all the required fields in the “Manual Reporting” form and click “Submit”.</p>
 </div>
;
const text6 = 
<div>
    <p>“Useful time” is the amount of time spent working in the “Work”, “Communication”, or “Learning” categories.</p>
 </div>
;
export default class SeventhBlock extends React.Component {


  render() {
    return (
      
     <div className={styles.main}>
        <span className={styles.mainTitle}>Frequently Asked Questions</span>
        <div  className={styles.mainWrap}>
        <Accordion>
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative">
                    How can I register and start using DueFocus?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                            {text1}
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative u-margin-bottom-s">
                    What is the difference between estimated and planned time?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                        {text2}
                </AccordionItemBody>
            </AccordionItem >
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative u-margin-bottom-s">
                    What is "Cold Start"?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                        {text3}
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative u-margin-bottom-s">
                    Can I switch screenshotting on/off?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                    {text4}
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative u-margin-bottom-s">
                    How can I create a manual report?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                    {text5}
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemTitle>
                    <strong className="acc_header u-position-relative u-margin-bottom-s">
                    What's “Useful” time?
                        <div className="accordion__arrow" role="presentation" />
                    </strong>
                </AccordionItemTitle>
                <AccordionItemBody>
                    {text6}
                </AccordionItemBody>
            </AccordionItem>
        </Accordion>
        </div>
     </div>
    )
  }
}
